import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import './boxHeader.css';

import { useDispatch, useSelector } from 'react-redux';
import {
  eSIMStatus,
  getActiveInterface,
  getBoxCarrier,
  getBoxPower,
  getBoxVoltage,
  getIsBoxOnline,
  getSignalStrength,
} from '../../../../actions/EpikBoxes';
import SpinnerCircles from '../../../../components/Spinner/SpinerCircles';
import AddLocationModal from '../../../../components/AddLocationModal';
import { userRoles } from '../../../../utils/constants';
import socketIOClient from 'socket.io-client';
import { Button } from 'reactstrap';
import PingModal from '../../../../components/PingModal';
import utils from '../../../../lib/utils';
import InfoPopup from '../../../../components/InfoPopup';
import Heart from '../../../../Res/Icon/pulse.png';
import Signals from '../../../../components/Signals';
import activeCarrierImg from '../../../../Res/Icon/CarrierIcon.png';
import dataCenter from '../../../../Res/Icon/data_center.png';
import { ReactComponent as VoltageSvg } from '../../../../Res/Icon/Voltage.svg';
import { ReactComponent as TempSvg } from '../../../../Res/Icon/temp.svg';
import { ReactComponent as SimIcon } from '../../../../Res/svg/sim_card_icon.svg';

import registeredIcon from '../../../../Res/Icon/registered_icon.png';

const {
  REACT_APP_LA_SHELL_URL,
  REACT_APP_CH_SHELL_URL,
  REACT_APP_NY_SHELL_URL,
  REACT_APP_AT_SHELL_URL,
} = process.env;
export const dataCenterShellUrls = {
  la: REACT_APP_LA_SHELL_URL,
  ch: REACT_APP_CH_SHELL_URL,
  ny: REACT_APP_NY_SHELL_URL,
  at: REACT_APP_AT_SHELL_URL,
};
const DC_ABBR = {
  la: 'LOS ANGELES',
  ch: 'CHICAGO',
  ny: 'NEW YORK',
  at: 'ATLANTA',
  nypingavg: 'NY',
};
const NO_DATA = `<span class="no-data">No Data<span>`;
const BoxCard = ({
  boxClass,
  onBoxClick = null,
  valueStyle,
  icon1,
  title,
  valueClass,
  value,
  pingButton,
  disablePing,
  onPing,
  testID,
  labelStyle,
  icon2 = {}
}) => {
  return (
    <div
      className={boxClass ? boxClass : `${value.loading ? 'boxPropertyloading ' : ''}boxProperty`}
      onClick={onBoxClick}
      id={`test-${testID ? testID : 'model'}`}
    >
      <div className="propertyNameContainer" id={`test-${testID ? testID : 'model'}-label`}>
        {icon1?.children ? (
          <>{icon1.children}</>
        ) : (
          <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon={icon1} />
        )}
        <span style={labelStyle} className="propertyName">
          {title}
        </span>
        {icon2?.children && <span id={`CustomerSIM${testID}`}> {icon2.children}
          <InfoPopup id={`CustomerSIM${testID}`} text={'Customer SIM'} infoIcon={false} />
        </span>}
        {value.loading && (
          <div style={{ marginRight: 10, marginTop: 10 }} class="loader">
            Loading...
          </div>
        )}
      </div>
      <div>
        <span
          className={valueClass ? `${valueClass}` : 'propertyValue'}
          id={`test-${testID ? testID : 'model'}-value`}
          style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
        >
          {value?.value?.children ? (
            value?.value.children
          ) : (
            <span
              style={{ marginTop: 5, ...valueStyle }}
              dangerouslySetInnerHTML={{ __html: value.value || '' }}
            />
          )}
          {pingButton && (
            <Button
              className="ping-btn"
              disabled={disablePing}
              onClick={() => onPing(value.value)}
              id={`test-${testID ? testID : 'model'}-ping-btn`}
            >
              <p>ping</p>
            </Button>
          )}
        </span>
      </div>
    </div>
  );
};
export default function({ isBoxOnline }) {
  const token = localStorage.getItem('jwtToken') || null;
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const dispatch = useDispatch();
  const user = useSelector(state => state.AppState.user);
  const [addLocationModal, setAddLocationModal] = useState(false);
  const [pingRes, setPingRes] = useState([]);
  const [processId, setProcessId] = useState('');
  const [stateSocket, setStateSocket] = useState(null);
  const [disablePing, setDisablePing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [esim, setEsim] = useState(false);
  const [data, setData] = useState({
    activeInterface: { loading: true, value: boxDetails.priorityInterface || NO_DATA },
    signals: { loading: true, value: { children: <Signals /> } },
    power: { loading: true, value: boxDetails.powerState || NO_DATA },
    carrier: { loading: true, value: NO_DATA },
    devicePower: { loading: true, value: boxDetails.power || NO_DATA },
    temp: { loading: true, value: boxDetails.temp || NO_DATA },
  });
  const boxStatus = isBoxOnline => (isBoxOnline ? 'Online' : 'Offline');
  useEffect(() => {
    //active interface
    dispatch(getActiveInterface(token, boxDetails._id, boxDetails.vpnAddress))
      .then(value => {
        setData(data => ({ ...data, activeInterface: { loading: false, value } }));
      })
      .catch(null);
    if (boxDetails.myEpik) return;
    // signal strength
    dispatch(getSignalStrength(token, boxDetails._id))
      .then(value => {
        setData(data => ({ ...data, signals: { ...data.signals, loading: false } }));
      })
      .catch(null);
    //box esim
    dispatch(eSIMStatus(token, boxDetails._id))
      .then(value => {
        setEsim(value);
      })
      .catch(null);
    //power state
    dispatch(getBoxPower(token, boxDetails._id))
      .then(value => {
        setData(data => ({
          ...data,
          power: { loading: false, value: value || NO_DATA },
        }));
      })
      .catch(null);
    //carrier
    dispatch(getBoxCarrier(token, boxDetails._id))
      .then(value => {
        setData(data => ({
          ...data,
          carrier: { loading: false, value: value || NO_DATA },
        }));
      })
      .catch(null);
    //power and volt
    dispatch(getBoxVoltage(token, boxDetails.vpnAddress))
      .then(value => {
        setData(data => ({
          ...data,
          devicePower: { loading: false, value: (value && value.power) || NO_DATA },
          temp: { loading: false, value: (value && value.temperature) || NO_DATA },
        }));
      })
      .catch(null);
  }, []);

  const onPing = ip => {
    setDisablePing(true);
    const baseUrl = dataCenterShellUrls[boxDetails.datacenter];
    const socket = socketIOClient.connect(baseUrl, { query: { token } });
    console.log('CONNECTION SOCKET');
    socket.on('connect', () => {
      setStateSocket(socket);
      console.log('Successfully connected!');
    });
    const { serialNumber } = boxDetails;
    const serialNumberDash = `${serialNumber}-${user._id}`;
    console.log('[SOCKET] emit : ', ip);
    socket.emit('PING_REQUEST', { serialNumber: serialNumberDash, ip: ip, shouldStop: false });
    pingRequest(serialNumberDash, socket);
  };

  const handlePingClose = () => {
    console.log('[SOCKET] close : ', processId);
    const { serialNumber } = boxDetails;
    setIsOpen(false);
    if (stateSocket)
      stateSocket.emit('STOP_PING', { serialNumber: serialNumber, shouldStop: true, processId });
    setProcessId('');
    setPingRes([]);
    setDisablePing(false);
  };

  const pingRequest = (serialNumberDash, socket) => {
    console.log('[SOCKET] on : ', serialNumberDash);
    let ping = [];
    socket.on(serialNumberDash, data => {
      if (data.processId) {
        setProcessId(data.processId);
      } else {
        ping = [...ping, data.pingResponse];
        setPingRes(ping);
      }
    });
    setIsOpen(true);
  };

  const freeSwitchRegistration = () =>
    boxDetails.everythingOnline ? 'Registered' : 'Unregistered';

  const boxMonitoring = () => (boxDetails.monitor ? 'Monitored' : 'Unmonitored');

  return (
    <div className="boxOverviewContainer">
      <BoxCard icon1="network-wired" title="Active Interface" value={data.activeInterface} />
      <BoxCard
        icon1="map-marker-alt"
        title="Location Name"
        value={{ value: boxDetails?.locRef?.locationName || NO_DATA }}
        onBoxClick={() => setAddLocationModal(true)}
      />
      <BoxCard
        icon1="map-marker-alt"
        title="Serial Number"
        value={{ value: boxDetails.serialNumber || NO_DATA }}
      />
      {userRoles.authenticateAdmin(user.role) && (
        <BoxCard
          icon1="network-wired"
          title="EPIK Edge Address"
          testID="epik-edge-address"
          value={{ value: boxDetails.vpnAddress }}
          pingButton={!!boxDetails.vpnAddress}
          onPing={onPing}
          disablePing={disablePing}
        />
      )}
      <BoxCard
        icon1="ethernet"
        title="Customer Provided IP"
        testID="customer-provided-ip"
        value={{ value: boxDetails?.customerProvidedIp || NO_DATA }}
        pingButton={!!boxDetails?.customerProvidedIp}
        onPing={onPing}
        disablePing={disablePing}
      />
      {utils.filterCustomer(user?.role) && (
        <>
          <BoxCard
            icon1="ethernet"
            title="LTE IP"
            testID="lte-ip"
            value={{ value: boxDetails.lteIp || NO_DATA }}
            pingButton={!!boxDetails.lteIp || !(boxDetails.modems?.length === 2 || !esim)}
            onPing={onPing}
            disablePing={disablePing}
            icon2={{ children: boxDetails.customerProvideSIM1 ? <SimIcon width={20} height={20} /> : null }}
          />
          {!!boxDetails.lteIp2 && (
            <BoxCard
              icon1="ethernet"
              title="LTE IP 2"
              testID="lte-ip-2"
              value={{ value: boxDetails.lteIp2 || NO_DATA }}
              pingButton={!!boxDetails.lteIp2 || !(boxDetails.modems?.length === 2 || !esim)}
              onPing={onPing}
              disablePing={disablePing}
              icon2={{ children: boxDetails.customerProvideSIM2 ? <SimIcon width={20} height={20} /> : null }}
            />
          )}
        </>
      )}
      <BoxCard
        icon1={{ children: <img src={Heart} alt="heart" className="labelIcon" /> }}
        title="Status"
        value={{ ...isBoxOnline, value: boxStatus(isBoxOnline?.value) }}
      />
      <BoxCard
        icon1={'wifi'}
        title="Signal Strength"
        value={data.signals}
        valueClass={'position-relative h-75 pb-1 d-flex justify-content-center'}
      />
      <BoxCard
        icon1={'power-off'}
        title="Power State"
        value={data.power}
        valueStyle={{ fontSize: data.power.value?.length > 10 ? '18px' : '32px' }}
      />
      <BoxCard
        icon1={{
          children: <img src={registeredIcon} fixedWidth className="labelIcon" alt={''} />,
        }}
        title="vSwitch"
        value={{ value: freeSwitchRegistration() }}
        valueStyle={{ fontSize: freeSwitchRegistration()?.length > 10 ? '24px' : '32px' }}
      />
      <BoxCard
        icon1={'bell'}
        title="Monitoring State"
        value={{ value: boxMonitoring() }}
        valueStyle={{
          fontSize: boxMonitoring().length > 10 ? '24px' : '32px',
        }}
      />
      <BoxCard
        icon1={{
          children: <img src={activeCarrierImg} fixedWidth className="labelIcon" alt={''} />,
        }}
        title="Active Carrier"
        value={data.carrier}
        valueStyle={{ fontSize: data.carrier.value?.length > 10 ? '20px' : '32px' }}
      />
      <BoxCard
        icon1={{
          children: <img src={dataCenter} fixedWidth className="labelIcon" alt={''} height={35} />,
        }}
        title="Active Data Center"
        value={{ value: DC_ABBR[boxDetails.datacenter] }}
        valueStyle={{ fontSize: DC_ABBR[boxDetails.datacenter]?.length > 10 ? '20px' : '32px' }}
      />
      <BoxCard
        icon1={{
          children: <VoltageSvg width={17} />,
        }}
        title="Device Power"
        value={data.devicePower}
        valueStyle={{
          fontSize: '32px',
        }}
      />
      <BoxCard
        icon1={{
          children: <TempSvg width={17} />,
        }}
        title="CPU Temp"
        value={data.temp}
        valueStyle={{
          fontSize: '30px',
        }}
      />
      {boxDetails?.locRef && (
        <AddLocationModal
          disabled
          formData={boxDetails.locRef}
          isOpen={addLocationModal}
          onCancel={() => setAddLocationModal(false)}
        />
      )}
      {isOpen && <PingModal isOpen={isOpen} onCancel={() => handlePingClose()} data={pingRes} />}
    </div>
  );
}
